type PageName = 'login' | 'top'

/**
 * locationPathが指定したページに相当するかどうかを判定する
 *
 * @param {string} locationPath - location.hrefを期待
 * @param {PageName} targetPage - 判定したいページ名
 * @returns {boolean}
 */
export const existThere = (locationPath: string, targetPage: PageName): boolean => {
  const arr = locationPath.split('/')
  if (arr[arr.length - 1].includes(targetPage)) {
    return true
  }
  return false
}
